import * as RolService from '@/services/RolService';

export function authRequest (state) {
  state.authStatus = 'loading';
}

export function authSuccess (state) {
  state.authStatus = 'success';
}

export function authError (state) {
  state.authStatus = 'error';
}

export async function setUser (state, value) {
  RolService.mutateAdmintoSuperAdmin(value);

  const isAdmin = RolService.isAdminAnyClient();
  if (isAdmin) value.role.push('admin');

  state.isLoggedIn = true;
  state.user = value;

  await RolService.isAnyEntidadAdmin(value);
  await RolService.isAnyDeliveryUser(value);
}

export function setUserType (state, value) {
  state.user.isExternal = !value;
}

export function setUserAppsAuthorized (state, value) {
  state.user.appAuthorized = value;
}

export function clearDataUser (state) {
  state.user = {};
  state.isLoggedIn = false;
  state.authStatus = '';
}

export function refreshToggleMenu (state, value) {
  state.sideBarmenuIsOpen = value;
}

export function haveEntidadesVisibles (state, value) {
  state.entidadesVisibles = value;
}

export function haveEntidadesVisiblesRelated (state, value) {
  state.entidadesVisiblesRelated = value;
}

export function setIsAdminEntidad (state, value) {
  state.isAdminEntidad = value;
}

export function setIsDeliveryUser (state, value) {
  state.isDeliveryUser = value;
}
